import { cx } from 'class-variance-authority';
const root = cx(['[&_a]:z-[1]', 'relative']);
const overlay = cx('top-0 left-0 w-full h-full z-0 absolute');
export const styles = {
    root,
    overlay,
};
